import React, {useState} from "react";
import styled from "styled-components";
import {rewardPeriodLabel} from "../../performance/period";
import {darkBoxShadowColour} from "../../../style/styleConsts";
import LoggingLink from "../../elements/LoggingLink";
import MorePeriods from "./MorePeriods";

const PeriodWrapper = styled.div`
    display: flex;
    height: 36px;
    flex-shrink: 0;
    color: #9e9892;
    font-size: 16px;
    padding-left: 18px;
    justify-content: flex-end;
`;

const PeriodNavigation = styled.nav`
    display: flex;
`;

const Period = styled.div`
    display: flex;
    padding-top: 5px;
    padding-bottom: 2px;
    flex-shrink: 0;
    justify-content: center;
    color: #9e9892;
    width: 105px;
    
    &.current {
        color: #3b7433;
        border-bottom: 5px solid #3b7433;
    }
`;

export const PeriodLink = styled(LoggingLink)`
    cursor: pointer;
    text-decoration: none;    
    transition: background-color 0.2s ease;
    
    :hover {
        background-color: ${darkBoxShadowColour};
    }
`;

const AvailablePeriods = ({
                                periods,
                                isSelectedPeriod,
                                periodPath,
                                loggingPayloadFor,
                                onChangePeriod = (isCurrentSelection) => {},
                                viewingOnDate
                            }) => {
    const [showMenu, setShowMenu] = useState(false);
    const allPeriods = periods ? periods.slice().reverse() : [];

    function onNavigation(isCurrentSelection) {
        setShowMenu(false);
        onChangePeriod(isCurrentSelection);
    }

    function toPeriodLink(p) {
        const key = `${p.periodBasis}/${p.startDate}`;
        const isCurrentSelection = isSelectedPeriod(p.periodBasis, p.startDate);
        const className = isCurrentSelection ? "t-period-selection current" : "t-period-selection";
        const rewardLabel = rewardPeriodLabel(p, viewingOnDate).toUpperCase();
        const period = <Period className={className} onClick={() => onNavigation(isCurrentSelection)} key={key}>{rewardLabel}</Period>;
        const path = periodPath(p.periodBasis, p.startDate);
        return path ? <PeriodLink to={path} key={key}
                                  className="t-period-link"
                                  loggingPayload={loggingPayloadFor(p)}>{period}</PeriodLink> : period;
    }

    const periodItems = allPeriods.slice(0, 3).map(toPeriodLink);

    const morePeriods = allPeriods.length <= 3 ? null : <MorePeriods periods={allPeriods.slice(3)}
                                                                     loggingPayloadFor={loggingPayloadFor}
                                                                     viewingOnDate={viewingOnDate}
                                                                     periodPath={periodPath}
                                                                     showMenu={showMenu}
                                                                     setShowMenu={setShowMenu}
                                                                     isSelectedPeriod={isSelectedPeriod}/>;

    return <PeriodWrapper className="t-available-periods">
        <PeriodNavigation>
            {periodItems}
            {morePeriods}
        </PeriodNavigation>
    </PeriodWrapper>
};

export default AvailablePeriods;